// Lives alone so consumers that only need the error type (e.g. the mutation
// error toast, whose unit tests run without a DOM) do not drag the whole
// session module — and its window-touching imports — into their module graph.
export class NoSessionFoundError extends Error {
  constructor() {
    super("No session found");
    this.name = "NoSessionFoundError";
  }
}
